/// <reference types="@angular/localize" />

import { provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { MainModule } from './app/main.module';
import { platformBrowser, provideClientHydration, withEventReplay } from '@angular/platform-browser';

platformBrowser()
  .bootstrapModule(MainModule, {
    applicationProviders: [
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideBrowserGlobalErrorListeners(),
      provideClientHydration(withEventReplay()),
    ],
  })
  .catch((err) => console.error(err));
